import { CreateCompanyFormInitState, FormSubmitHandlerProps } from "./types";
import { FormikValues } from "formik/dist/types";
import { mapBackendValidationErrors } from "../../../utils/form";
import { createProperty } from "../../../api/property";
import { DEFAULT_MAP_LAT, DEFAULT_MAP_LNG } from "../../../ui/map/utils";
import { route } from "../../../utils/url";
import { HTTP_STATUS_CODES } from "../../../types/server";

export const createCompanyFormInitState: CreateCompanyFormInitState = {
  object_name: "",
  notes: "",
  location: {
    place_id: "",
    lat: DEFAULT_MAP_LAT,
    lng: DEFAULT_MAP_LNG,
    city: "",
    house_number: "",
    zip_code: "",
    country: "",
    state_code: "",
  },
};

export const touchedInitState = {
  state: false,
  object_name: false,
  street_id: false,
  city: false,
  house_number: false,
  zip_code: false,
  notes: false,
};

/* istanbul ignore next */
export const handleCreateCompanyFormSubmit = ({
  setFormMessage,
  navigate,
}: FormSubmitHandlerProps) => {
  return async (
    values: CreateCompanyFormInitState,
    { setStatus, setSubmitting, resetForm }: FormikValues
  ): Promise<void> => {
    const response = await createProperty(values);
    const json = await response.json();
    if (response.status === HTTP_STATUS_CODES.CREATED) {
      resetForm({
        errors: {},
        touched: {},
      });
      setStatus({
        success: true,
        errors: {},
        company: json.data,
      });
      navigate(route("companies"));
    } else if (response.status === HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY) {
      setStatus({
        success: false,
        errors: mapBackendValidationErrors(json.errors),
      });
      setSubmitting(false);
    } else {
      setFormMessage({ type: "error", text: "errorSomethingWentWrong" });
      setSubmitting(false);
    }
  };
};

export const initPlaceAddressData = {
  place_id: undefined,
  street: undefined,
  house_number: undefined,
  zip_code: undefined,
  city: undefined,
  state_code: undefined,
  country: undefined,
};
